import React from 'react';
import { Reveal } from './Reveal';
import { ArrowLeft, ArrowRight } from 'lucide-react';
export const TestimonialsSection = () => {
  const scrollCarousel = (direction: number) => {
    const track = document.getElementById('testimonials-track');
    if (track) {
      const card = track.querySelector(':scope > *') as HTMLElement;
      if (card) {
        const cardWidth = card.offsetWidth + 24;
        track.scrollBy({
          left: cardWidth * direction,
          behavior: 'smooth'
        });
      }
    }
  };
  return <section className="py-10 md:py-16 bg-rose-soft overflow-hidden" data-id="element-362">
      <div className="max-w-[1400px] mx-auto px-[5vw]" data-id="element-363">
        <Reveal data-id="element-364">
          <div className="mb-8 md:mb-10 flex flex-col md:flex-row md:items-end justify-between gap-6" data-id="element-365">
            <div data-id="element-366">
              <span className="font-caveat text-rose text-2xl block mb-4" data-id="element-367">
                quem já tá usando
              </span>
              <h2 className="font-serif font-bold text-[clamp(34px,5vw,56px)] tracking-[-0.02em] text-ink" data-id="element-368">
                Histórias de quem parou <br data-id="element-369" /> de trabalhar de graça
              </h2>
            </div>

            <div className="flex gap-4" data-id="element-370">
              <button onClick={() => scrollCarousel(-1)} className="w-12 h-12 rounded-full border border-ink/15 flex items-center justify-center text-ink hover:bg-white transition-all" data-id="element-371">
                <ArrowLeft size={20} data-id="element-372" />
              </button>
              <button onClick={() => scrollCarousel(1)} className="w-12 h-12 rounded-full border border-ink/15 flex items-center justify-center text-ink hover:bg-white transition-all" data-id="element-373">
                <ArrowRight size={20} data-id="element-374" />
              </button>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.2} data-id="element-375">
          <div id="testimonials-track" className="carousel-track pb-8" data-id="element-376">
            {/* Testimonial 1 */}
            <div className="carousel-card w-[320px] md:w-[400px] bg-white rounded-[28px] p-8 shadow-soft relative" data-id="element-377">
              <div className="absolute top-6 right-8 font-serif text-[80px] leading-none text-rose opacity-20" data-id="element-378">
                "
              </div>
              <p className="font-serif italic text-[16px] md:text-[19px] text-ink mb-8 relative z-10 min-h-[120px]" data-id="element-379">
                "Eu vendia lembrancinha de chá de bebê por R$ 12 achando que
                tava ganhando. Botei tudo no Aurora e descobri que perdia R$ 4
                em cada uma. Em 80 unidades, R$ 320 que sumiam todo pedido. Hoje
                cobro R$ 18 e a cliente nem questiona, porque agora EU sei o
                porquê do preço."
              </p>
              <div className="flex items-center gap-4" data-id="element-380">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-gold-soft to-gold flex items-center justify-center font-serif font-bold text-white text-lg" data-id="element-381">
                  M
                </div>
                <div data-id="element-382">
                  <p className="font-semibold text-[15px] text-ink" data-id="element-383">
                    Marta R., 52
                  </p>
                  <p className="text-[13px] text-ink-soft" data-id="element-384">Belo Horizonte/MG</p>
                </div>
              </div>
            </div>

            {/* Testimonial 2 */}
            <div className="carousel-card w-[320px] md:w-[400px] bg-white rounded-[28px] p-8 shadow-soft relative" data-id="element-385">
              <div className="absolute top-6 right-8 font-serif text-[80px] leading-none text-rose opacity-20" data-id="element-386">
                "
              </div>
              <p className="font-serif italic text-[16px] md:text-[19px] text-ink mb-8 relative z-10 min-h-[120px]" data-id="element-387">
                "Eu sou aquela artesã que não tem paciência pra tecnologia. Já
                comprei 3 planilhas e nunca usei nenhuma. Levei 5 minutos pra
                cadastrar meu primeiro produto no Aurora. Cinco minutos. Pensei:
                se era só isso, por que ninguém me mostrou antes?"
              </p>
              <div className="flex items-center gap-4" data-id="element-388">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-gold-soft to-gold flex items-center justify-center font-serif font-bold text-white text-lg" data-id="element-389">
                  C
                </div>
                <div data-id="element-390">
                  <p className="font-semibold text-[15px] text-ink" data-id="element-391">
                    Cláudia S., 47
                  </p>
                  <p className="text-[13px] text-ink-soft" data-id="element-392">Caruaru/PE</p>
                </div>
              </div>
            </div>

            {/* Testimonial 3 */}
            <div className="carousel-card w-[320px] md:w-[400px] bg-white rounded-[28px] p-8 shadow-soft relative" data-id="element-393">
              <div className="absolute top-6 right-8 font-serif text-[80px] leading-none text-rose opacity-20" data-id="element-394">
                "
              </div>
              <p className="font-serif italic text-[16px] md:text-[19px] text-ink mb-8 relative z-10 min-h-[120px]" data-id="element-395">
                "O que mudou pra mim não foi o lucro — foi a tranquilidade.
                Antes, quando a cliente perguntava o preço, eu travava no
                WhatsApp. Hoje eu olho o app, vejo o número e mando. Sem voz
                tremida, sem desconto pra compensar, sou outra confeiteira."
              </p>
              <div className="flex items-center gap-4" data-id="element-396">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-gold-soft to-gold flex items-center justify-center font-serif font-bold text-white text-lg" data-id="element-397">
                  P
                </div>
                <div data-id="element-398">
                  <p className="font-semibold text-[15px] text-ink" data-id="element-399">
                    Patrícia L., 39
                  </p>
                  <p className="text-[13px] text-ink-soft" data-id="element-400">Curitiba/PR</p>
                </div>
              </div>
            </div>
          </div>
          {/* Note: These are placeholder testimonials and should be replaced with real ones before publishing. */}
        </Reveal>
      </div>
    </section>;
};